import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getAdminTeamMemberById, updateTeamMember } from "../api/team.api";
import { uploadImage, uploadPdf } from "../api/upload.api";

export default function EditTeam() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const data = await getAdminTeamMemberById(id);
      setForm(data);
    };
    load();
  }, [id]);

  if (!form) return <p>Loading...</p>;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let imageName = form.photo;
      let pdfName = form.cv;

      if (imageFile) {
        imageName = await uploadImage(imageFile);
      }

      if (pdfFile) {
        pdfName = await uploadPdf(pdfFile);
      }

      await updateTeamMember(id, {
        name: form.name,
        category: form.category,
        position: form.position,
        education: form.education,
        bio: form.bio,
        cv: pdfName,
        photo: imageName
      });

      alert("Team member updated!");
      navigate("/admin/team");
    } catch (err) {
      console.error(err);
      alert("Failed to update team member");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="container py-5">
      <h2>Edit Team Member</h2>
      <form onSubmit={handleSubmit}>
        <input name="name" value={form.name} onChange={handleChange} className="form-control mb-2" />
        <select name="category" value={form.category} onChange={handleChange} className="form-control mb-2">
          <option value="member">Membership</option>
          <option value="leadership">Leadership</option>
        </select>
        <input name="position" value={form.position} onChange={handleChange} className="form-control mb-2" />
        <input name="education" value={form.education} onChange={handleChange} className="form-control mb-2" />
        <textarea name="bio" value={form.bio} onChange={handleChange} className="form-control mb-2" />
        <input 
          type="file" 
          accept="application/pdf" 
          onChange={(e) => setPdfFile(e.target.files[0])}
          className="form-control mb-2"
        />
        
        {form.photo && (
        <div>
          <p>Current image:</p>
          <img
            src={`https://node.lcwe-lb.com/uploads/images/${form.photo}`}
            alt="Current"
            style={{ width: 150 }}
          />
        </div>
      )}

        <input 
          type="file" 
          accept="image/*"
          onChange={(e) => setImageFile(e.target.files[0])} 
          className="form-control mb-2" 
        />

        <button type="submit" className="btn btn-primary">Update</button>
      </form>
    </div>
  );
}
